export default "__VITE_ASSET__8be2729d__"